// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1kJST","noInteraction":"EventWrapper_noInteraction__Om_pY"};